export default __webpack_public_path__ + "static/media/18.640df0d1.png";